import { useState, useEffect } from "react";
import httpService from "../common/services/http-service";

const useApi = (url, params = {}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const fetchData = async () => {
    try {
      const resonse = await httpService.get(url, params);
      setData(resonse.data);
      setLoading(false);
    } catch (err) {
      setError(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return { loading, data, error };
};

export default useApi;
